import { Box } from '@rbilabs/universal-components';

import { withTypography } from 'components/ui';

export const ContentContainer = Box.withConfig({
  paddingY: '0',
  marginBottom: '$6',
});

export const ModalHeading = withTypography({
  variant: 'headerOne',
  mt: '$2',
});

export const ModalBody = withTypography({ fontSize: 'md', my: '$2' });
